"use strict";

var _toConsumableArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayMove = exports.shuffle = exports.getArrayLastNElements = exports.findArrayIndexOfValueByAttr = exports.findArrayIndexOfValue = exports.isValueInArray = exports.sortArrayByAttribute = exports.compareArrayEntries = exports.compareArrayEntriesWAttr = exports.compareArrayEntriesDepth = exports.flattenArray = exports.createArrayOfLength = exports.isNestedObjectAttrInArray = exports.isObjectAttrInArray = exports.isObjectInArray = exports.sumArrayBoolean = exports.arrayBooleanToInt = void 0;

var number_1 = require("./number");

exports.arrayBooleanToInt = function (arr) {
  return arr.map(function (a) {
    if (a === true) {
      return 1;
    }

    return 0;
  });
};

exports.sumArrayBoolean = function (arr) {
  return number_1.sum(exports.arrayBooleanToInt(arr));
};

exports.isObjectInArray = function (k, arr) {
  var a = arr.indexOf(k);

  if (a === -1) {
    return null;
  }

  return a;
};

exports.isObjectAttrInArray = function (k, arr) {
  var attr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "id";
  var idx = null;
  arr.filter(function (d, i) {
    if (d[attr] && d[attr] === k) {
      idx = i;
      return d;
    }

    return d;
  });
  return idx;
};

exports.isNestedObjectAttrInArray = function (k, arr, nest) {
  var attr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "id";
  var idx = null;
  arr.filter(function (d, i) {
    if (d[nest]) {
      if (d[nest][attr] && d[nest][attr] === k) {
        idx = i;
        return d;
      }
    }

    return d;
  });
  return idx;
};

exports.createArrayOfLength = function (n) {
  var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return Array.from({
    length: n
  }, function (v, k) {
    return k + idx;
  });
};

exports.flattenArray = function (arr) {
  return [].concat.apply([], arr);
};

exports.compareArrayEntriesDepth = function (a, b, attr) {
  var s = attr.split(".");
  var ca = a[attr];
  var cb = b[attr];

  switch (s.length) {
    case 3:
      ca = a[s[0]][s[1]][s[2]];
      cb = b[s[0]][s[1]][s[2]];
      break;

    case 2:
      ca = a[s[0]][s[1]];
      cb = b[s[0]][s[1]];
      break;

    default:
      ca = a[s[0]];
      cb = b[s[0]];
      break;
  }

  return exports.compareArrayEntries(ca, cb);
};

exports.compareArrayEntriesWAttr = function (a, b, attr) {
  return exports.compareArrayEntries(a[attr], b[attr]);
};

exports.compareArrayEntries = function (a, b) {
  if (a < b) {
    return -1;
  }

  if (a > b) {
    return 1;
  }

  return 0;
};

exports.sortArrayByAttribute = function (array) {
  var attr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "name";
  var asc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var compareFn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : exports.compareArrayEntriesWAttr;
  var r = array.sort(function (a, b) {
    return compareFn(a, b, attr);
  });

  if (asc) {
    return r;
  }

  return r.reverse();
};

exports.isValueInArray = function (array, value) {
  var attr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "id";
  return array.find(function (a) {
    return a[attr] === value;
  });
};

exports.findArrayIndexOfValue = function (array, value) {
  var r = null;
  array.map(function (a, i) {
    if (a === value) {
      r = i;
    }

    return true;
  });
  return r;
};

exports.findArrayIndexOfValueByAttr = function (array, value) {
  var attr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "id";
  var r = null;
  array.map(function (a, i) {
    if (a[attr] === value) {
      r = i;
    }

    return true;
  });
  return r;
};

exports.getArrayLastNElements = function (arr, n) {
  var arraySize = arr.length;

  if (arraySize <= n) {
    return arr;
  }

  return arr.slice(arraySize - n, arraySize);
};

exports.shuffle = function (source) {
  var arr = _toConsumableArray(source);

  for (var i = arr.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var _ref = [arr[j], arr[i]];
    arr[i] = _ref[0];
    arr[j] = _ref[1];
  }

  return arr;
};

var arrayMoveMutate = function arrayMoveMutate(array, from, to) {
  var startIndex = to < 0 ? array.length + to : to;

  if (startIndex >= 0 && startIndex < array.length) {
    var item = array.splice(from, 1)[0];
    array.splice(startIndex, 0, item);
  }
};

exports.arrayMove = function (array, from, to) {
  array = _toConsumableArray(array);
  arrayMoveMutate(array, from, to);
  return array;
};